import { z } from 'zod';
import { CardEnum } from '../CardState.ts';
import { createKeyRecordSchema } from '../KeyRecordSchemas.ts';
import { createPartialStrictObjectSchemaWithAtLeastOneProperty } from '../PartialStrictObjectSchema.ts';
import { validateState } from '../ValidateState.ts';
import { EnumUtils } from '@colonist/utils';
import { PlayerColor } from '../PlayerState.ts';
const mechanicCityPlayerStateSchema = z.object({
    bankCityAmount: z.number().int().nonnegative(),
    nextCityDiscount: z.union([
        z.array(z.enum(CardEnum)),
        z.null()
    ]).exactOptional()
}).strict();
const playerColorNumericKeys = EnumUtils.getEnumValues(PlayerColor);
export const mechanicCityStateSchema = createKeyRecordSchema(playerColorNumericKeys, mechanicCityPlayerStateSchema);
export function validateMechanicCityState(data) {
    return validateState(mechanicCityStateSchema, data);
}
const mechanicCityPlayerStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(mechanicCityPlayerStateSchema);
export const mechanicCityStatePartialSchema = createKeyRecordSchema(playerColorNumericKeys, mechanicCityPlayerStatePartialSchema, {
    requireAtLeastOneEntry: true
});
